import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import download from 'downloadjs';
import config from '../../../../globs/config';
import { getInstrumentedAxiosInstance } from '../../../../globs/ajax-proxy';
import FormattedCurrencyNumberCustom from '../../../formatted-currency-number-custom/index';
import DownloadIcon from './download-icon2.png';

class TransactionRow extends React.Component {
  static propTypes = {
    transaction: PropTypes.shape({}).isRequired,
    user: PropTypes.shape({
      locale: PropTypes.string,
    }).isRequired,
    customerID: PropTypes.shape({}).isRequired,
  }
  constructor() {
    super();
    this.state = { someKey: 'someKey' };
  }

  // onDownloadBtnClick = (invoice, creditControlArea) => {
  //   const { props, state } = this;
  //   const { customerID } = this.props;
  //   // console.log('transaction inside TransactionRow ===>',this.props);
  //   if (state.isLoading) return;
  //   const token = localStorage.getItem('token');
  //   const headers = {
  //     Accept: 'application/hal+json',
  //     'x-token-authorization': token,
  //   };
  //   this.setState({
  //     invoiceNo: invoice,
  //     isLoading: true,
  //     success: false,
  //     error: false,
  //   });
  //   const _path = `${config.apiContextPath}/sales_officers/${props.user.id}/businesses/${props.customerID}/get_invoice_pdf?invoice_number=${invoice}&credit_control_area=${creditControlArea}`;
  //   // axios.get(_path, { headers })
  //   getInstrumentedAxiosInstance().get(_path)
  //     .then((response) => {
  //       console.log('resp inside if===>', response);
  //       if (response.data.errorMsg || response.data.noData) {
  //         this.setState({
  //           error: true,
  //           isLoading: false,
  //         });
  //       } else {
  //         console.log('resp inside else===>', response);
  //         const content = response.headers['content-type'];
  //         window.postMessage(download(response.data, `${invoice}.pdf`, content));
  //         this.setState({
  //           success: true,
  //           error: false,
  //           isLoading: false,
  //         });
  //       }
  //     })
  //     .catch(error => console.log(error));
  // }

  onDownloadBtnClick = (invoice, creditControlArea) => {
    const { props, state } = this;

    if (state.isLoading) return;

    this.setState({
      invoiceNo: invoice,
      isLoading: true,
      success: false,
      error: false,
    });

    const _path = `${config.apiContextPath}/sales_officers/${props.user.id}/businesses/${props.customerID}/get_invoice_pdf?invoice_number=${invoice}&credit_control_area=${creditControlArea}`;

    const hexToBlob = (hex) => {
      const bytes = new Uint8Array(
        hex.match(/.{1,2}/g).map(b => parseInt(b, 16))
      );
      return new Blob([bytes], { type: 'application/pdf' });
    };

    getInstrumentedAxiosInstance()
      .get(_path, { responseType: 'blob' })
      .then(async (response) => {
        let blob;

        if (response.data instanceof Blob) {
          blob = response.data;
          const text = await blob.text();
          if (/^[0-9a-fA-F]+$/.test(text)) {
            blob = hexToBlob(text);
          }
        } 

        else if (typeof response.data === 'string') {
          blob = hexToBlob(response.data);
        }

        if (!blob || blob.size === 0) {
          console.error('Empty PDF, skipping download');
          this.setState({ error: true, isLoading: false });
          return;
        }

        window.postMessage(download(blob, `${invoice}.pdf`, 'application/pdf'));

        this.setState({
          success: true,
          error: false,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ error: true, isLoading: false });
      });
  };

  render() {
    const { transaction, user } = this.props;
    console.log('transaction.delivery_note_numbers===>', transaction.delivery_note_numbers);
    let heading = '';
    let icon = '';
    let classname = '';
    if (transaction.transaction_type === 'PAY') {
      heading = 'Payment';
      icon = 'icon-payment';
    } else if (transaction.transaction_type === 'INV') {
      heading = 'Open Invoice';
      icon = 'icon-open_invoice';
      classname = 'lr-icon-openInvoice';
    } else if (transaction.transaction_type === 'CIN') {
      icon = 'icon-clear_invoice';
      heading = 'Cleared Invoice';
      // classname = 'lr-icon-clearedInvoice';
    } else if (transaction.transaction_type === 'REB') {
      icon = 'icon-rebate';
      heading = 'Rebate'; //
      classname = '';
    }
    if (this.props.user.locale === 'ar-EG') {
      if ((transaction.transaction_type === 'CIN' || transaction.transaction_type === 'INV') && transaction.document_type_code === 'DN') {
        icon = 'icon-rebate'; // credit note
        heading = 'Credit Note';
        classname = '';
      } else if ((transaction.transaction_type === 'CIN' || transaction.transaction_type === 'INV') && transaction.document_type_code === 'DF') {
        icon = ''; // credit note
        heading = 'Debit Note';
        classname = 'debit-note-icon';
      } else if ((transaction.transaction_type === 'CIN' || transaction.transaction_type === 'INV') && transaction.document_type_code === 'SA') {
        icon = ''; // credit note
        heading = 'Manual Entry';
        classname = 'manual-entry-icon';
      }
    } else {
      if ((transaction.transaction_type === 'CIN' || transaction.transaction_type === 'INV') && transaction.document_type_code === 'DD') {
        icon = 'icon-rebate';
        heading = 'Rebate'; //
        classname = 'status-rebate';
      }
      if ((transaction.transaction_type === 'CIN' || transaction.transaction_type === 'INV') && transaction.document_type_code === 'DG') {
        icon = 'icon-rebate'; // credit note
        heading = 'Credit Note';
        classname = '';
      }
    }
    if (transaction.transaction_type === 'OB') {
      heading = "Opening Balance";
      icon = 'icon-rebate';
      classname = 'status-rebate';
    }
    if (transaction.transaction_type === 'RCT') {
      heading = "Receipt";
      icon = 'icon-rebate';
      classname = 'status-rebate';
    }
    if (transaction.transaction_type === 'DN') {
      heading = "Debit Note";
      icon = 'icon-rebate';
      classname = 'status-rebate';
    }
    if (transaction.transaction_type === 'CN') {
      heading = "Credit Note";
      icon = 'icon-rebate';
      classname = 'status-rebate';
    }
    if (transaction.transaction_type === 'CB') {
      heading = "Closing Balance";
      icon = 'icon-rebate';
      classname = 'status-rebate';
    }
    if (transaction.transaction_type === 'UL') {
      heading = "Un Invoiced Loads";
      icon = 'icon-rebate';
      classname = 'status-rebate';
    }
    return (
      <div className={`lr-statment-row ${classname}`}>
        <div className={`lr-statment-row__status lr-statment-row__status ${classname}`} >
          <i className={icon} />
        </div>
        <div className="lr-statment-quantity">
          <span>
            <FormattedCurrencyNumberCustom value={transaction.amount} currency={transaction.currency} />
          </span>
        </div>
        <div className="lr-statment-row__product-name">
          <span className="overflow-ellipsis lr-customer-row__name"><div>{heading}</div></span>
        </div>
        <div className="lr-statment-row__product-name">
          <span className="newdate">{transaction.transaction_date ? moment(transaction.transaction_date).format('DD.MM.YYYY') : ''} | {(transaction.transaction_type === 'INV' || transaction.transaction_type === 'CIN') && transaction.assignment ? transaction.assignment : transaction.document_Number} | {transaction.text_reference}
          </span>
          {
            transaction.transaction_type === 'INV' && icon !== 'icon-rebate' &&
            <span className="newdate payment-due-date"><div>Payment due by</div> : <span className="date-green">{transaction.due_date ? moment(transaction.due_date).format('DD.MM.YYYY').toString() : '-'}</span></span>
          }
          <span className="overflow-ellipsis lr-statment-row__last-payment" />
          {
            transaction.delivery_note_numbers && transaction.delivery_note_numbers.length > 0 &&
            <div>
              <span className="delivery-note-info">
                <span>Delivery note</span>:
                {
                  transaction.delivery_note_numbers.map(number => (
                    <span className="lr-delivery-no" key={`'delrow-${Math.random(15000)}'`}>{number.document_number}</span>
                  ))
                }
              </span>
            </div>
          }
          <div className="invoice-download-container">
            <span>
              {
                this.state.error &&
                <span className="invoice-download-error">Invoice PDF is not available</span>
              }
              {
                this.state.success &&
                <span className="invoice-download-successful">PDF download successful. Please check notification / Downloads folder</span>
              }
            </span>
            <span>
              {
                user.settings_data.ENABLE_INVOICE_PDF_DOWNLOAD &&
                transaction.reference_key && transaction.credit_control_area &&
                <button
                  className="invoice-download"
                  disabled={this.state.isLoading}
                  onClick={() => this.onDownloadBtnClick(transaction.reference_key,
                  transaction.credit_control_area)}
                >
                  <img 
                    className={`${(transaction.reference_key === this.state.invoiceNo && this.state.isLoading) ? 'downloading-animation' : ''}`} 
                    src={DownloadIcon} 
                    alt="Download" 
                  />
                </button>
              }
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export default TransactionRow;
